import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MasterModel } from '../masters/states/masters/masters.model';
import { GpsLocation } from './symbols';

@Injectable()
export class GpsLocationService {
  readonly apiUrl = '/api/gps-location';

  constructor(private http: HttpClient) {
  }

  updateLocation(updateLocation: GpsLocation) {
    return this.http.patch(`${this.apiUrl}/update-location`, updateLocation);
  }


  requestLocations(): Observable<MasterModel> {
    return this.http.post<MasterModel>(`${this.apiUrl}/request-locations`, {});
  }
}
